import * as api from '../api/event';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'EVENTS/EVENT';

export const EVENT_FETCH_START = `${namespace}/EVENT_FETCH_START`;
export const EVENT_FETCH_SUCCESS = `${namespace}/EVENT_FETCH_SUCCESS`;
export const EVENT_FETCH_ERROR = `${namespace}/EVENT_FETCH_ERROR`;

export const EVENT_TAGS_FETCH_START = `${namespace}/EVENT_TAGS_FETCH_START`;
export const EVENT_TAGS_FETCH_SUCCESS = `${namespace}/EVENT_TAGS_FETCH_SUCCESS`;
export const EVENT_TAGS_FETCH_ERROR = `${namespace}/EVENT_TAGS_FETCH_ERROR`;

export const EVENT_OBJECTS_FETCH_START = `${namespace}/EVENT_OBJECTS_FETCH_START`;
export const EVENT_OBJECTS_FETCH_SUCCESS = `${namespace}/EVENT_OBJECTS_FETCH_SUCCESS`;
export const EVENT_OBJECTS_FETCH_ERROR = `${namespace}/EVENT_OBJECTS_FETCH_ERROR`;

export const EVENT_CREATE_START = `${namespace}/EVENT_CREATE_START`;
export const EVENT_CREATE_SUCCESS = `${namespace}/EVENT_CREATE_SUCCESS`;
export const EVENT_CREATE_ERROR = `${namespace}/EVENT_CREATE_ERROR`;

export const EVENT_UPDATE_START = `${namespace}/EVENT_UPDATE_START`;
export const EVENT_UPDATE_SUCCESS = `${namespace}/EVENT_UPDATE_SUCCESS`;
export const EVENT_UPDATE_ERROR = `${namespace}/EVENT_UPDATE_ERROR`;

export const EVENT_UPDATE_TAG_OBJECT_START = `${namespace}/EVENT_UPDATE_TAG_OBJECT_START`;
export const EVENT_UPDATE_TAG_OBJECT_SUCCESS = `${namespace}/EVENT_UPDATE_TAG_OBJECT_SUCCESS`;
export const EVENT_UPDATE_TAG_OBJECT_ERROR = `${namespace}/EVENT_UPDATE_TAG_OBJECT_ERROR`;

export const EVENT_DELETE_START = `${namespace}/EVENT_DELETE_START`;
export const EVENT_DELETE_SUCCESS = `${namespace}/EVENT_DELETE_SUCCESS`;
export const EVENT_DELETE_ERROR = `${namespace}/EVENT_DELETE_ERROR`;

export const EVENT_DOCUMENTS_FETCH_START = `${namespace}/EVENT_DOCUMENTS_FETCH_START`;
export const EVENT_DOCUMENTS_FETCH_SUCCESS = `${namespace}/EVENT_DOCUMENTS_FETCH_SUCCESS`;
export const EVENT_DOCUMENTS_FETCH_ERROR = `${namespace}/EVENT_DOCUMENTS_FETCH_ERROR`;

export const EVENT_DESCRIPTION_CODEFILE_FETCH_START = `${namespace}/EVENT_DESCRIPTION_CODEFILE_FETCH_START`;
export const EVENT_DESCRIPTION_CODEFILE_FETCH_SUCCESS = `${namespace}/EVENT_DESCRIPTION_CODEFILE_FETCH_SUCCESS`;
export const EVENT_DESCRIPTION_CODEFILE_FETCH_ERROR = `${namespace}/EVENT_DESCRIPTION_CODEFILE_FETCH_ERROR`;

export const EVENT_DOCUMENT_CREATE_START = `${namespace}/EVENT_DOCUMENT_CREATE_START`;
export const EVENT_DOCUMENT_CREATE_SUCCESS = `${namespace}/EVENT_DOCUMENT_CREATE_SUCCESS`;
export const EVENT_DOCUMENT_CREATE_ERROR = `${namespace}/EVENT_DOCUMENT_CREATE_ERROR`;

export const EVENT_DOCUMENT_DELETE_START = `${namespace}/EVENT_DOCUMENT_DELETE_START`;
export const EVENT_DOCUMENT_DELETE_SUCCESS = `${namespace}/EVENT_DOCUMENT_DELETE_SUCCESS`;
export const EVENT_DOCUMENT_DELETE_ERROR = `${namespace}/EVENT_DOCUMENT_DELETE_ERROR`;

export const EVENT_DOCUMENT_GET_START = `${namespace}/EVENT_DOCUMENT_GET_START`;
export const EVENT_DOCUMENT_GET_SUCCESS = `${namespace}/EVENT_DOCUMENT_GET_SUCCESS`;
export const EVENT_DOCUMENT_GET_ERROR = `${namespace}/EVENT_DOCUMENT_GET_ERROR`;

export const EVENT_DOCUMENT_UPDATE_START = `${namespace}/EVENT_DOCUMENT_UPDATE_START`;
export const EVENT_DOCUMENT_UPDATE_SUCCESS = `${namespace}/EVENT_DOCUMENT_UPDATE_SUCCESS`;
export const EVENT_DOCUMENT_UPDATE_ERROR = `${namespace}/EVENT_DOCUMENT_UPDATE_ERROR`;

export const EVENT_INACTIVATE_START = `${namespace}/EVENT_INACTIVATE_START`;
export const EVENT_INACTIVATE_SUCCESS = `${namespace}/EVENT_INACTIVATE_SUCCESS`;
export const EVENT_INACTIVATE_ERROR = `${namespace}/EVENT_INACTIVATE_ERROR`;

export const EVENT_ACTIVATE_START = `${namespace}/EVENT_ACTIVATE_START`;
export const EVENT_ACTIVATE_SUCCESS = `${namespace}/EVENT_ACTIVATE_SUCCESS`;
export const EVENT_ACTIVATE_ERROR = `${namespace}/EVENT_ACTIVATE_ERROR`;

export const EVENT_REVISION_HISTORY_FETCH_START = `${namespace}/EVENT_REVISION_HISTORY_FETCH_START`;
export const EVENT_REVISION_HISTORY_FETCH_SUCCESS = `${namespace}/EVENT_REVISION_HISTORY_FETCH_SUCCESS`;
export const EVENT_REVISION_HISTORY_FETCH_ERROR = `${namespace}/EVENT_REVISION_HISTORY_FETCH_ERROR`;

export const RESET_EVENT = `${namespace}/RESET_EVENT`;
export const SET_CURRENT_EVENT = `${namespace}/SET_CURRENT_EVENT`;
export const SET_PERSISTS = `${namespace}/SET_PERSISTS`;
export const SET_LAST_EDIT_POSITION = `${namespace}/SET_LAST_EDIT_POSITION`;
export const SET_LAST_TOP_POSITION = `${namespace}/SET_LAST_TOP_POSITION`;

export const INIT_UPLOAD_IMAGES = `${namespace}/INIT_UPLOAD_IMAGES`;
export const DELETE_UPLOADED_IMAGE = `${namespace}/DELETE_UPLOADED_IMAGE`;

export const EVENT_IMAGE_DELETE_START = `${namespace}/EVENT_IMAGE_DELETE_START`;
export const EVENT_IMAGE_DELETE_SUCCESS = `${namespace}/EVENT_IMAGE_DELETE_SUCCESS`;
export const EVENT_IMAGE_DELETE_ERROR = `${namespace}/EVENT_IMAGE_DELETE_ERROR`;

export const EVENT_IMAGE_UPDATE_START = `${namespace}/EVENT_IMAGE_UPDATE_START`;
export const EVENT_IMAGE_UPDATE_SUCCESS = `${namespace}/EVENT_IMAGE_UPDATE_SUCCESS`;
export const EVENT_IMAGE_UPDATE_ERROR = `${namespace}/EVENT_IMAGE_UPDATE_ERROR`;

export const EVENT_IMAGE_FOR_EVENT_UPDATE_START = `${namespace}/EVENT_IMAGE_FOR_EVENT_UPDATE_START`;
export const EVENT_IMAGE_FOR_EVENT_UPDATE_SUCCESS = `${namespace}/EVENT_IMAGE_FOR_EVENT_UPDATE_SUCCESS`;
export const EVENT_IMAGE_FOR_EVENT_UPDATE_ERROR = `${namespace}/EVENT_IMAGE_FOR_EVENT_UPDATE_ERROR`;

export const EVENT_IMAGE_DOWNLOAD_START = `${namespace}/EVENT_IMAGE_DOWNLOAD_START`;
export const EVENT_IMAGE_DOWNLOAD_SUCCESS = `${namespace}/EVENT_IMAGE_DOWNLOAD_SUCCESS`;
export const EVENT_IMAGE_DOWNLOAD_ERROR = `${namespace}/EVENT_IMAGE_DOWNLOAD_ERROR`;

export const EVENT_IMAGES_UPLOAD_START = `${namespace}/EVENT_IMAGES_UPLOAD_START`;
export const EVENT_IMAGES_UPLOAD_SUCCESS = `${namespace}/EVENT_IMAGES_UPLOAD_SUCCESS`;
export const EVENT_IMAGES_UPLOAD_ERROR = `${namespace}/EVENT_IMAGES_UPLOAD_ERROR`;

export const EVENTS_IMAGE_ATTACH_START = `${namespace}/EVENTS_IMAGE_ATTACH_START`;
export const EVENTS_IMAGE_ATTACH_SUCCESS = `${namespace}/EVENTS_IMAGE_ATTACH_SUCCESS`;
export const EVENTS_IMAGE_ATTACH_ERROR = `${namespace}/EVENTS_IMAGE_ATTACH_ERROR`;

export const EVENTS_IMAGES_ATTACH_START = `${namespace}/EVENTS_IMAGES_ATTACH_START`;
export const EVENTS_IMAGES_ATTACH_SUCCESS = `${namespace}/EVENTS_IMAGES_ATTACH_SUCCESS`;
export const EVENTS_IMAGES_ATTACH_ERROR = `${namespace}/EVENTS_IMAGES_ATTACH_ERROR`;

export const EVENT_LINKED_IMAGE_FETCH_START = `${namespace}/EVENT_LINKED_IMAGE_FETCH_START`;
export const EVENT_LINKED_IMAGE_FETCH_SUCCESS = `${namespace}/EVENT_LINKED_IMAGE_FETCH_SUCCESS`;
export const EVENT_LINKED_IMAGE_FETCH_ERROR = `${namespace}/EVENT_LINKED_IMAGE_FETCH_ERROR`;

export const EVENT_LINKED_IMAGE_DELETE_START = `${namespace}/EVENT_LINKED_IMAGE_DELETE_START`;
export const EVENT_LINKED_IMAGE_DELETE_SUCCESS = `${namespace}/EVENT_LINKED_IMAGE_DELETE_SUCCESS`;
export const EVENT_LINKED_IMAGE_DELETE_ERROR = `${namespace}/EVENT_LINKED_IMAGE_DELETE_ERROR`;

export const EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_START = `${namespace}/EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_START`;
export const EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_SUCCESS = `${namespace}/EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_SUCCESS`;
export const EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_ERROR = `${namespace}/EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_ERROR`;

export const EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_START = `${namespace}/EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_START`;
export const EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_SUCCESS = `${namespace}/EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_SUCCESS`;
export const EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_ERROR = `${namespace}/EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_ERROR`;

export const EVENT_LINKED_IMAGES_FETCH_START = `${namespace}/EVENT_LINKED_IMAGES_FETCH_START`;
export const EVENT_LINKED_IMAGES_FETCH_SUCCESS = `${namespace}/EVENT_LINKED_IMAGES_FETCH_SUCCESS`;
export const EVENT_LINKED_IMAGES_FETCH_ERROR = `${namespace}/EVENT_LINKED_IMAGES_FETCH_ERROR`;

export const EVENT_LINKED_EVENTS_FETCH_START = `${namespace}/EVENT_LINKED_EVENTS_FETCH_START`;
export const EVENT_LINKED_EVENTS_FETCH_SUCCESS = `${namespace}/EVENT_LINKED_EVENTS_FETCH_SUCCESS`;
export const EVENT_LINKED_EVENTS_FETCH_ERROR = `${namespace}/EVENT_LINKED_EVENTS_FETCH_ERROR`;

export const ASSOCIATE_PROPERTY_OWNERS_EVENTS_START = `${namespace}/ASSOCIATE_PROPERTY_OWNERS_EVENTS_START`;
export const ASSOCIATE_PROPERTY_OWNERS_EVENTS_SUCCESS = `${namespace}/ASSOCIATE_PROPERTY_OWNERS_EVENTS_SUCCESS`;
export const ASSOCIATE_PROPERTY_OWNERS_EVENTS_ERROR = `${namespace}/ASSOCIATE_PROPERTY_OWNERS_EVENTS_ERROR`;

export const REMOVE_PROPERTY_OWNERS_EVENTS_START = `${namespace}/REMOVE_PROPERTY_OWNERS_EVENTS_START`;
export const REMOVE_PROPERTY_OWNERS_EVENTS_SUCCESS = `${namespace}/REMOVE_PROPERTY_OWNERS_EVENTS_SUCCESS`;
export const REMOVE_PROPERTY_OWNERS_EVENTS_ERROR = `${namespace}/REMOVE_PROPERTY_OWNERS_EVENTS_ERROR`;

export const fetchEvent = makeApiActionCreatorV3(
  api.fetchEvent,
  EVENT_FETCH_START,
  EVENT_FETCH_SUCCESS,
  EVENT_FETCH_ERROR,
);

export const fetchEventTags = makeApiActionCreatorV3(
  api.fetchEventTags,
  EVENT_TAGS_FETCH_START,
  EVENT_TAGS_FETCH_SUCCESS,
  EVENT_TAGS_FETCH_ERROR,
);

export const fetchEventObjects = makeApiActionCreatorV3(
  api.fetchEventObjects,
  EVENT_OBJECTS_FETCH_START,
  EVENT_OBJECTS_FETCH_SUCCESS,
  EVENT_OBJECTS_FETCH_ERROR,
);

export const createEvent = makeApiActionCreatorV3(
  api.createEvent,
  EVENT_CREATE_START,
  EVENT_CREATE_SUCCESS,
  EVENT_CREATE_ERROR,
);

export const updateEvent = makeApiActionCreatorV3(
  api.updateEvent,
  EVENT_UPDATE_START,
  EVENT_UPDATE_SUCCESS,
  EVENT_UPDATE_ERROR,
);

export const updateEventTagObject = makeApiActionCreatorV3(
  api.updateEventTagObject,
  EVENT_UPDATE_TAG_OBJECT_START,
  EVENT_UPDATE_TAG_OBJECT_SUCCESS,
  EVENT_UPDATE_TAG_OBJECT_ERROR,
);

export const deleteEvent = makeApiActionCreatorV3(
  api.deleteEvent,
  EVENT_DELETE_START,
  EVENT_DELETE_SUCCESS,
  EVENT_DELETE_ERROR,
);

export const activateEvent = makeApiActionCreatorV3(
  api.activateEvent,
  EVENT_ACTIVATE_START,
  EVENT_ACTIVATE_SUCCESS,
  EVENT_ACTIVATE_ERROR,
);

export const inactivateEvent = makeApiActionCreatorV3(
  api.inactivateEvent,
  EVENT_INACTIVATE_START,
  EVENT_INACTIVATE_SUCCESS,
  EVENT_INACTIVATE_ERROR,
);

export const fetchDocuments = makeApiActionCreatorV3(
  api.fetchDocuments,
  EVENT_DOCUMENTS_FETCH_START,
  EVENT_DOCUMENTS_FETCH_SUCCESS,
  EVENT_DOCUMENTS_FETCH_ERROR,
);

export const fetchDescriptionCodefile = makeApiActionCreatorV3(
  api.fetchDescriptionCodefile,
  EVENT_DESCRIPTION_CODEFILE_FETCH_START,
  EVENT_DESCRIPTION_CODEFILE_FETCH_SUCCESS,
  EVENT_DESCRIPTION_CODEFILE_FETCH_ERROR,
);

export const createDocument = makeApiActionCreatorV3(
  api.createDocument,
  EVENT_DOCUMENT_CREATE_START,
  EVENT_DOCUMENT_CREATE_SUCCESS,
  EVENT_DOCUMENT_CREATE_ERROR,
);

export const deleteDocument = makeApiActionCreatorV3(
  api.deleteDocument,
  EVENT_DOCUMENT_DELETE_START,
  EVENT_DOCUMENT_DELETE_SUCCESS,
  EVENT_DOCUMENT_DELETE_ERROR,
);

export const getDocument = makeApiActionCreatorV3(
  api.getDocument,
  EVENT_DOCUMENT_GET_START,
  EVENT_DOCUMENT_GET_SUCCESS,
  EVENT_DOCUMENT_GET_ERROR,
);

export const updateDocument = makeApiActionCreatorV3(
  api.updateDocument,
  EVENT_DOCUMENT_UPDATE_START,
  EVENT_DOCUMENT_UPDATE_SUCCESS,
  EVENT_DOCUMENT_UPDATE_ERROR,
);

export const fetchEventRevisionHistory = makeApiActionCreatorV3(
  api.fetchEventRevisionHistory,
  EVENT_REVISION_HISTORY_FETCH_START,
  EVENT_REVISION_HISTORY_FETCH_SUCCESS,
  EVENT_REVISION_HISTORY_FETCH_ERROR,
);

export const uploadEventImages = makeApiActionCreatorV3(
  api.uploadEventImages,
  EVENT_IMAGES_UPLOAD_START,
  EVENT_IMAGES_UPLOAD_SUCCESS,
  EVENT_IMAGES_UPLOAD_ERROR,
);

export const attachEventsImage = makeApiActionCreatorV3(
  api.attachEventsImage,
  EVENTS_IMAGE_ATTACH_START,
  EVENTS_IMAGE_ATTACH_SUCCESS,
  EVENTS_IMAGE_ATTACH_ERROR,
);

export const attachEventsImages = makeApiActionCreatorV3(
  api.attachEventsImages,
  EVENTS_IMAGES_ATTACH_START,
  EVENTS_IMAGES_ATTACH_SUCCESS,
  EVENTS_IMAGES_ATTACH_ERROR,
);

export const fetchEventLinkedImages = makeApiActionCreatorV3(
  api.fetchEventLinkedImages,
  EVENT_LINKED_IMAGES_FETCH_START,
  EVENT_LINKED_IMAGES_FETCH_SUCCESS,
  EVENT_LINKED_IMAGES_FETCH_ERROR,
);

export const fetchEventLinkedImage = makeApiActionCreatorV3(
  api.fetchEventLinkedImage,
  EVENT_LINKED_IMAGE_FETCH_START,
  EVENT_LINKED_IMAGE_FETCH_SUCCESS,
  EVENT_LINKED_IMAGE_FETCH_ERROR,
);

export const deleteEventLinkedImageForImage = makeApiActionCreatorV3(
  api.deleteEventLinkedImage,
  EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_START,
  EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_SUCCESS,
  EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_ERROR,
);

export const deleteEventLinkedImageForEvent = makeApiActionCreatorV3(
  api.deleteEventLinkedImage,
  EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_START,
  EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_SUCCESS,
  EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_ERROR,
);

export const fetchLinkedEvents = makeApiActionCreatorV3(
  api.fetchLinkedEvents,
  EVENT_LINKED_EVENTS_FETCH_START,
  EVENT_LINKED_EVENTS_FETCH_SUCCESS,
  EVENT_LINKED_EVENTS_FETCH_ERROR,
);

export const updateEventImageForEvent = makeApiActionCreatorV3(
  api.updateEventImage,
  EVENT_IMAGE_FOR_EVENT_UPDATE_START,
  EVENT_IMAGE_FOR_EVENT_UPDATE_SUCCESS,
  EVENT_IMAGE_FOR_EVENT_UPDATE_ERROR,
);

export const updateEventImage = makeApiActionCreatorV3(
  api.updateEventImage,
  EVENT_IMAGE_UPDATE_START,
  EVENT_IMAGE_UPDATE_SUCCESS,
  EVENT_IMAGE_UPDATE_ERROR,
);

export const downloadEventImage = makeApiActionCreatorV3(
  api.downloadEventImage,
  EVENT_IMAGE_DOWNLOAD_START,
  EVENT_IMAGE_DOWNLOAD_SUCCESS,
  EVENT_IMAGE_DOWNLOAD_ERROR,
);

export const deleteEventImage = makeApiActionCreatorV3(
  api.deleteEventImage,
  EVENT_IMAGE_DELETE_START,
  EVENT_IMAGE_DELETE_SUCCESS,
  EVENT_IMAGE_DELETE_ERROR,
);

export const assoicatePropertyOwnerstoEvents = makeApiActionCreatorV3(
  api.assoicatePropertyOwnerstoEvents,
  ASSOCIATE_PROPERTY_OWNERS_EVENTS_START,
  ASSOCIATE_PROPERTY_OWNERS_EVENTS_SUCCESS,
  ASSOCIATE_PROPERTY_OWNERS_EVENTS_ERROR,
);

export const removePropertyOwnerstoEvents = makeApiActionCreatorV3(
  api.removePropertyOwnerstoEvents,
  REMOVE_PROPERTY_OWNERS_EVENTS_START,
  REMOVE_PROPERTY_OWNERS_EVENTS_SUCCESS,
  REMOVE_PROPERTY_OWNERS_EVENTS_ERROR,
);
export const initUploadImages = () => ({
  type: INIT_UPLOAD_IMAGES,
});

export const deleteUploadedImage = file => ({
  type: DELETE_UPLOADED_IMAGE,
  payload: file,
});

export const setCurrentEvent = event => ({
  type: SET_CURRENT_EVENT,
  payload: event,
});

export const resetEvent = () => ({
  type: RESET_EVENT,
});

export const setPersists = payload => ({
  type: SET_PERSISTS,
  payload,
});

export const setLastEditPosition = payload => ({
  type: SET_LAST_EDIT_POSITION,
  payload,
});

export const setLastTopPosition = payload => ({
  type: SET_LAST_TOP_POSITION,
  payload,
});
